import {debounce} from "../../../_src/js/Util";

let peopleSlider;

const onResizeCompany = debounce(() => {
    // Если десктоп, то сьроим слайдер "руководства"
    if (App.W.outerWidth() > 999) {
        personsSlider();
    } else {
        if (peopleSlider !== undefined) {
            peopleSlider.destroy(true, true);
        }
    }
}, 300);


if ($(".js-people-slider").length) {
    App.W.on('resize', () => {
        onResizeCompany();
    });

    onResizeCompany();
}

function personsSlider() {
    peopleSlider = new Swiper('.js-people-slider', {
        spaceBetween: 24,
        slidesPerView: 4,
        navigation: {
            prevEl: '.js-people-slider-prev',
            nextEl: '.js-people-slider-next'
        },
    });
}

if ($(".js-offices-slider").length) {
    $(".js-offices-slider").each(function() {
        const officesSlider = new Swiper(this, {
            enabled: false,
            navigation: {
                nextEl: $(this).closest('.section-offices').find('.js-offices-slider-next')[0],
                prevEl: $(this).closest('.section-offices').find('.js-offices-slider-prev')[0],
            },
            breakpoints: {
                768: {
                    enabled: true,
                    spaceBetween: 49,
                    slidesPerView: "auto",
                },
                1140: {
                    enabled: true,
                    slidesPerView: 3,
                    spaceBetween: 49,
                },
            },
        });
    });

    $(".js-offices-toggle").on("click", function () {
        $(this).siblings(".js-offices-slider").addClass("_opened");
    });
}